export const state = {
  category_list: []
}
